import { useMutation } from "react-query";
import { submitPublicCertificateDownloadForm } from "./gateway";
import { enqueueSnackbar } from "notistack";
import fileDownload from "js-file-download";
import { useTranslation } from "react-i18next";

function useSubmitPublicCertificateDownloadForm() {
  const { t } = useTranslation();
  return useMutation({
    mutationFn: submitPublicCertificateDownloadForm,
    mutationKey: ["submitPublicCertificateDownloadForm"],
    onSuccess: (data) => {
      const filename =
        data.headers["content-disposition"].split("filename*=utf-8''")[1];
      fileDownload(data.data, filename);
      enqueueSnackbar("Επιτυχές κατέβασμα πιστοποιητικού", {
        variant: "success",
      });
    },
  });
}

export default useSubmitPublicCertificateDownloadForm;
